import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '../Main.scss';

import { 
    PortalTextMainHamburgerMenu,
    PostLoginUserResponse,
} from '../../Models/Api/strongbox.financialportal';

import { ApplicationState } from '../../Store';
import { GetLoggedInUser, LoggedInUserHasAccess } from '../../Store/User';
import { 
    GetPortalText,
    GetPortalLanguageCode,
    PortalAssetsActionCreators,
} from '../../Store/PortalAssets';

import { LanguageSelectionEnabled } from '../../Store/AppSettings';

import { FinPortalDropdown } from '../FinPortalDropdown/FinPortalDropdown';

type InjectedReduxState = {
    loggedInUser?: PostLoginUserResponse;
    canAccessUserManagement: boolean;
    canAccessGlobalSubmissions: boolean;
    hamburgerMenuText?: PortalTextMainHamburgerMenu;
    canChangeLanguage: boolean;
    activeLanguageCode: string;
}

type InjectedActionCreators = typeof PortalAssetsActionCreators;

type LoggedInUserProps = {
    logout?: () => void;
    settings?: () => void;
    dataCollectionReport?: () => void;
    notificationSettings?: () => void;
    onPortalLanguageChange?: (languageCode: string) => void;
    hideMenu?: boolean;
};

type Props = LoggedInUserProps & InjectedActionCreators & InjectedReduxState;

export const LoggedInUserComponent: React.FC<Props> = (props): React.ReactElement => {
    const userDisplayName = React.useMemo(() => {
        if (!props.loggedInUser) {
            return '';
        }
        if (!!props.loggedInUser.displayName) {
            return props.loggedInUser.displayName;
        }
        if (!!(props.loggedInUser.firstName || props.loggedInUser.lastName)) {
            return `${props.loggedInUser.firstName ? props.loggedInUser.firstName + '' : ''}${props.loggedInUser.lastName || ''}`;
        }
        return props.loggedInUser.emailAddress;
    }, [props.loggedInUser]);

    if ((!props.loggedInUser) || (!props.hamburgerMenuText)) {
        return (<></>);
    }

    if (props.hideMenu === true) {
        return (<span className={'page-app-header__name'}>{userDisplayName}</span>);
    }

    return (
        <FinPortalDropdown
            label={userDisplayName}
            canAccessSettings={props.canAccessUserManagement}
            canAccessGlobalSubmissions={props.canAccessGlobalSubmissions}
            logout={props.logout}
            settings={props.settings}
            dataCollectionReport={props.dataCollectionReport}
            notificationSettings={props.notificationSettings}
            hamburgerText={props.hamburgerMenuText}
            canChangeLanguage={props.canChangeLanguage}
            activeLanguageCode={props.activeLanguageCode}
            onLanguageCodeChange={(languageCode) => {
                props.SetActiveLanguageCode(languageCode);
                !!props.onPortalLanguageChange && props.onPortalLanguageChange(languageCode);
            }}
        />
    );
}

export const LoggedInUser = connect<InjectedReduxState, InjectedActionCreators, LoggedInUserProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            loggedInUser: GetLoggedInUser(appState),
            canAccessUserManagement: LoggedInUserHasAccess(appState, 'CanManageUsers'),
            canAccessGlobalSubmissions: LoggedInUserHasAccess(appState, 'CanViewGlobalSubmissions'),
            hamburgerMenuText: GetPortalText<PortalTextMainHamburgerMenu>(appState, 'mainHamburgerMenu'),
            canChangeLanguage: LanguageSelectionEnabled(appState),
            activeLanguageCode: GetPortalLanguageCode(appState),
        };

        return result;
    },
    dispatch => bindActionCreators(
        {
            ...PortalAssetsActionCreators
        },
        dispatch
    )
)(LoggedInUserComponent);
